import { Button } from "../Button";
import "./styles.css";

const Empty = (props) => {
  return (
    <center className="empty-activity">
      <div className="icon-container">
        <span className={process.env.REACT_APP_ICONS_TYPE}>{props.icon}</span>
      </div>
      <div className="description-container">
        <span className="text-bold">{props.title}</span>
      </div>
      {props.showButton && (
        <div style={{ marginTop: "1rem" }}>
          <Button
            text={props.buttonText}
            className="btn-transparent primary underline"
            onPress={props.buttonPressed}
          />
        </div>
      )}
    </center>
  );
};

export default Empty;
